import React from 'react';
import NotificationLoading from './NotificationLoading';
import './styles.scss';

export default function LoadingState() {
  return (
    <div className="notification-center-loading-container">
      <NotificationLoading />
      <NotificationLoading />
      <NotificationLoading />
    </div>
  );
}
